import { TrafficShareWithVisits, UpgradeLink } from "app/components/React/Table/cells";
import { TableHeaderText, Text } from "app/pages/keyword-analysis/TotalTrafficPage/StyledComponents";
import { i18nFilter } from "app/filters/i18nFilter";
import { swPositionFilter } from "app/filters/ngFilters";
import {
    SearchOverviewTopKeywordTableRowContainer,
    DomainContainer,
    SearchOverviewTopKeywordTrafficShareHeaderContainerSingle,
    SearchOverviewTopKeywordTrendHeaderContainer,
    TopKeywordCoreWebsiteCellContainer,
    TrafficShareContainer,
    SearchOverviewTopKeywordHeader,
    VolumeContainer,
    StyledItemIconContainer,
    MaxWidthCoreWebsiteCellContainer,
    SearchOverviewHeaderContainer,
    TrafficShareHeaderContainer,
    TableRowContainer,
} from "../SearchOverviewTraffic/StyledComponent";
import { StyledItemIcon } from "pro-features/components/core cells/src/CoreRecentCell/StyledComponents";
import { KeywordCompetitorsAffinityCell } from "app/components/React/Table/cells/KeywordCompetitorsAffinityCell";
import { PlainTooltip } from "@similarweb/ui-components";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { InnerLinkContainer } from "pro-features/components/core cells/src/CoreWebsiteCell/StyledComponents";
import { allTrackers } from "app/services/track/track";

const DomainColumnHeaderKey = "search.overview.traffic.topKeywordsTable.column.header.keyword";
const SearchTrafficColumnHeaderKey = "search.overview.traffic.topKeywordsTable.column.header.searchTraffic";
const VolumeColumnHeaderKey = "search.overview.traffic.topKeywordsTable.column.header.volume";
const ColumnHeaderSize = 12;

const TopKeywordTableRow = (row, index, routingParams) => {
    const { SearchTerm: searchTerm, KwVolume: kwVolume } = row;
    const InnerLinkPage = "organicsearch_keywordAnalysis_overview_2";
    const innerLink = proNavigator.href(InnerLinkPage, { ...routingParams, keyword: searchTerm });
    const keywordClicked = () => {
        allTrackers.dispatchTrackEvent("Button", "click", `${searchTerm || ""}`);
    };
    const renderLink = () => {
        if (proNavigator.current().name.match(/accountreview_/)) {
            return <span>{searchTerm}</span>;
        }

        return searchTerm === "grid.upgrade" ? (
            <InnerLinkContainer alignItems="center">
                <UpgradeLink />
            </InnerLinkContainer>
        ) : (
            <a
                href={innerLink}
                onClick={keywordClicked}
            >
                {searchTerm}
            </a>
        );
    };
    return (
        <SearchOverviewTopKeywordTableRowContainer key={index}>
            <TopKeywordCoreWebsiteCellContainer>
                <Text>{renderLink()}</Text>
            </TopKeywordCoreWebsiteCellContainer>
            <TrafficShareContainer>
                <TrafficShareWithVisits
                    row={row}
                    value={row.TotalShare}
                />
            </TrafficShareContainer>
            <VolumeContainer>
                <Text>{swPositionFilter()(kwVolume)}</Text>
            </VolumeContainer>
        </SearchOverviewTopKeywordTableRowContainer>
    );
};

const OrganicCompetitorsTableRow = ({ Domain, Favicon, Affinity }, index) => {
    return (
        <TableRowContainer key={index}>
            <MaxWidthCoreWebsiteCellContainer>
                <StyledItemIconContainer>
                    <StyledItemIcon iconSrc={Favicon} />
                </StyledItemIconContainer>
                <Text>{Domain}</Text>
            </MaxWidthCoreWebsiteCellContainer>
            <KeywordCompetitorsAffinityCell value={Affinity} />
        </TableRowContainer>
    );
};

export const SearchOverviewTopKeywordTableComponentSingle = (props) => {
    const i18n = i18nFilter();
    const { searchOverviewTrafficData, routingParams } = props;
    return (
        <div>
            <SearchOverviewTopKeywordHeader>
                <DomainContainer>
                    <TableHeaderText fontSize={ColumnHeaderSize}>{i18n(DomainColumnHeaderKey)}</TableHeaderText>
                </DomainContainer>
                <SearchOverviewTopKeywordTrendHeaderContainer>
                    <TableHeaderText fontSize={ColumnHeaderSize}>{i18n(SearchTrafficColumnHeaderKey)}</TableHeaderText>
                </SearchOverviewTopKeywordTrendHeaderContainer>
                <SearchOverviewTopKeywordTrafficShareHeaderContainerSingle>
                    <TableHeaderText fontSize={ColumnHeaderSize}>{i18n(VolumeColumnHeaderKey)}</TableHeaderText>
                </SearchOverviewTopKeywordTrafficShareHeaderContainerSingle>
            </SearchOverviewTopKeywordHeader>
            {searchOverviewTrafficData.searchOverviewTrafficList.map((row, index) =>
                TopKeywordTableRow(row, index, routingParams),
            )}
        </div>
    );
};

export const SearchOverviewOrganicCompetitors = ({ searchOverviewTrafficData }) => {
    const i18n = i18nFilter();

    const domainTitle = i18n("analysis.competitors.search.organic.table.columns.domain.title");
    const searchOverlapTooltip = i18n(
        "analysis.competitors.search.organic.table.columns.affinity.last.three.months.tooltip",
    );
    const searchOverlapTooltipTitle = i18n("analysis.competitors.search.organic.table.columns.affinity.title");
    const overlapScoreTitle = i18n("analysis.competitors.search.organic.table.columns.affinity.title");

    return (
        <div>
            <SearchOverviewHeaderContainer>
                <DomainContainer>
                    <TableHeaderText fontSize={ColumnHeaderSize}>{domainTitle}</TableHeaderText>
                </DomainContainer>
                <TrafficShareHeaderContainer>
                    <PlainTooltip
                        tooltipContent={
                            <div className="u-flex-column">
                                <span className="u-bold">{searchOverlapTooltipTitle}</span>
                                <span>{searchOverlapTooltip}</span>
                            </div>
                        }
                    >
                        <TableHeaderText fontSize={ColumnHeaderSize}>{overlapScoreTitle}</TableHeaderText>
                    </PlainTooltip>
                </TrafficShareHeaderContainer>
            </SearchOverviewHeaderContainer>
            {searchOverviewTrafficData.searchOverviewTrafficList.map(OrganicCompetitorsTableRow)}
        </div>
    );
};
